export default __webpack_public_path__ + "static/Plots0066-8a578ed31a9fc5c95f864d9e6881f668.jpg";